class VideoOverlayButtonElement extends HTMLElement {
    static get observedAttributes() { 
      return ['src', 'target']; 
    }
    constructor() {
        super();
      	this.attachShadow({mode: 'open'});
        this.render();
    }
  
  get target() {
    return document.querySelector(this.getAttribute('target'));
  }

    handleClick(e) {
      this.updateVideoSource();
      this.target.show();
    }

    connectedCallback() {
        this.addEventListener('click', this.handleClick.bind(this))
    }

    disconnectedCallback() {
        this.removeEventListener('click', this.handleClick.bind(this))
    }

    attributeChangedCallback(name, oldValue, newValue) {
      switch(name) {
        case 'src':
          this.updateVideoSource(src);
          break;
        case 'target':
          this._target = newValue;
          break;
      }
    }

    render() {
        this.shadowRoot.innerHTML = `<slot>Watch Video</slot>`;
    }
  
    updateVideoSource() {
      const src = this.getAttribute('src');
	  const targetSrc = this.target.getAttribute('src')
      if(targetSrc !== src) {
		this.target.setAttribute('src', this.getAttribute('src'));       
      }
    }
}

window.customElements.define('video-overlay-button', VideoOverlayButtonElement)